import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import "../css/styles.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "@fortawesome/fontawesome-free/css/all.min.css";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

function formatCurrency(value) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value || 0);
}

function Gantt() {
  const [totalprojeto, setTotalprojeto] = useState();
  const [valorprojeto, setValorprojeto] = useState();
  const [maiorvalorprojeto, setMaiorvalorprojeto] = useState();
  const [valoresSecretarias, setValoresSecretarias] = useState({});

  useEffect(() => {
    axios
      .get("/api/totalprojeto")
      .then((res) => setTotalprojeto(res.data[0].total))
      .catch((err) => console.log(err));

    axios
      .get("/api/valorprojeto")
      .then((res) => setValorprojeto(res.data[0].valor))
      .catch((err) => console.log(err));

    axios
      .get("/api/maiorvalorprojeto")
      .then((res) => setMaiorvalorprojeto(res.data[0].maior))
      .catch((err) => console.log(err));

    axios
      .get("/api/valores-por-secretaria")
      .then((res) => {
        const valores = {};
        res.data.forEach((item) => {
          valores[item.secretaria] = Number(item.total_valor);
        });
        setValoresSecretarias(valores);
      })
      .catch((err) => console.log(err));
  }, []);

  const labels = [
    "02.13 - Secretaria Municipal da Agricultura",
    "02.07 - Secretaria Municipal de Obras e Serviços Municipais",
    "02.15 - Secretaria Municipal de Governo e Gestão Estratégica",
    "02.17 - Secretaria Municipal de Meio Ambiente",
    "SAEG",
    "CODESG",
    "02.03 - Secretaria Municipal de Planejamento, Coordenação e Habitação",
    "02.11 - Secretaria Municipal de Saúde",
    "02.09 - Secretaria Municipal da Educação",
    "02.08 - Secretaria Municipal de Segurança e Mobilidade Urbana",
    "02.11 - Secretaria Municipal de Turismo e Lazer",
    "02.10 - Secretaria Municpal de Esportes",
    "02.16 - Secretaria Municipal da Cultura",
    "02.20 -Secretaria de Políticas para as Mulheres",
    "Assessoria Especial de Defesa Civil",
    "02.05 - Secretaria Municipal da Administração",
  ];

  const displayLabels = [
    "Agricultura",
    "Obras",
    "Governo",
    "Meio Ambiente",
    "SAEG",
    "CODESG",
    "Planejamento",
    "Saúde",
    "Educação",
    "Segurança",
    "Turismo",
    "Esporte",
    "Cultura",
    "Mulher",
    "Defesa Civil",
    "Administração",
  ];

  const data = {
    labels: displayLabels,
    datasets: [
      {
        label: "Valor dos processos por secretaria",
        data: labels.map((label) => valoresSecretarias[label] || 0),
        backgroundColor: [
          "rgba(52, 152, 219, 0.7)",
          "rgba(231, 76, 60, 0.7)",
          "rgba(46, 204, 113, 0.7)",
          "rgba(155, 89, 182, 0.7)",
          "rgba(241, 196, 15, 0.7)",
          "rgba(230, 126, 34, 0.7)",
          "rgba(52, 73, 94, 0.7)",
          "rgba(26, 188, 156, 0.7)",
          "rgba(41, 128, 185, 0.7)",
          "rgba(192, 57, 43, 0.7)",
          "rgba(39, 174, 96, 0.7)",
          "rgba(142, 68, 173, 0.7)",
          "rgba(243, 156, 18, 0.7)",
          "rgba(211, 84, 0, 0.7)",
          "rgba(44, 62, 80, 0.7)",
          "rgba(22, 160, 133, 0.7)",
        ],
        borderColor: [
          "rgba(52, 152, 219, 1)",
          "rgba(231, 76, 60, 1)",
          "rgba(46, 204, 113, 1)",
          "rgba(155, 89, 182, 1)",
          "rgba(241, 196, 15, 1)",
          "rgba(230, 126, 34, 1)",
          "rgba(52, 73, 94, 1)",
          "rgba(26, 188, 156, 1)",
          "rgba(41, 128, 185, 1)",
          "rgba(192, 57, 43, 1)",
          "rgba(39, 174, 96, 1)",
          "rgba(142, 68, 173, 1)",
          "rgba(243, 156, 18, 1)",
          "rgba(211, 84, 0, 1)",
          "rgba(44, 62, 80, 1)",
          "rgba(22, 160, 133, 1)",
        ],
        borderWidth: 1,
        borderRadius: 5,
        barThickness: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) =>
            `Valor dos processos por secretaria: ${formatCurrency(
              context.raw
            )}`,
        },
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        padding: 10,
        titleFont: { size: 14 },
        bodyFont: { size: 14 },
      },
      legend: {
        display: true,
        position: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: { color: "rgba(0, 0, 0, 0.1)" },
        ticks: {
          callback: (value) => formatCurrency(value),
          font: { size: 12 },
        },
      },
      x: {
        grid: { display: false },
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          font: { size: 12 },
        },
      },
    },
  };

  return (
    <main className="main-container">
      <div className="containerdashboard">
        <h5
          className="m-0"
          style={{
            fontSize: "1.75rem",
            fontWeight: "bold",
            color: "#2c3e50",
            borderBottom: "3px solid #3498db",
            paddingBottom: "10px",
            display: "inline-block",
          }}
        >
          ESTRATIFICAÇÃO DO VALOR DOS PROCESSOS POR SECRETARIA
        </h5>

        <div className="main-cards">
          <div className="card">
            <div className="card-inner">
              <h5>Número de Processos</h5>
              <i
                className="fas fa-project-diagram"
                style={{ fontSize: "24px", color: "#3498db" }}
              ></i>
            </div>
            <hr />
            <div>
              <h5>Total: {totalprojeto || 0}</h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Processos ativos no sistema
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-inner">
              <h5>Valor estimado dos processos</h5>
              <i
                className="fas fa-dollar-sign"
                style={{ fontSize: "24px", color: "#2ecc71" }}
              ></i>
            </div>
            <hr />
            <div>
              <h5>{formatCurrency(valorprojeto)}</h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Investimento total
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-inner">
              <h5>Numero de Secretarias</h5>
              <i
                className="fas fa-star"
                style={{ fontSize: "24px", color: "#f1c40f" }}
              ></i>
            </div>
            <hr />
            <div>
              <h5>Total: {18}</h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Numero de secretarias
              </p>
            </div>
          </div>

          <div className="card">
            <div className="card-inner">
              <h5>Maior valor de um projeto</h5>
              <i
                className="fas fa-chart-line"
                style={{ fontSize: "24px", color: "#e74c3c" }}
              ></i>
            </div>
            <hr />
            <div>
              <h5>{formatCurrency(maiorvalorprojeto)}</h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Projeto de maior orçamento
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="containerdashboard">
        <div className="Gra" style={{ height: "500px" }}>
          <Bar data={data} options={options} />
        </div>
      </div>
    </main>
  );
}

export default Gantt;
